import React, { useEffect, useState } from 'react'

import { Box, Button, Menu, MenuItem, TextField, Tooltip, ListItemText, ListItemIcon } from '@mui/material'
import api from '../../api'
import useNotification from '../Notification'
import { getSession } from '../../auth'
import AddIcon  from '@mui/icons-material/Add'
import { markdownTranslator } from './functions'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const postMessage = async (cardId, journeyId, onSubmit, setText, setActive) => {
    const enterpriseId = getSession().profile.enterprise.id
    setText(async text => {
        const res = await api.post(`api/enterprises/${enterpriseId}/journeys/${journeyId}/opportunities/${cardId}/comment/`, {message: text})
        setActive(false)
        if (res.status === 201) {
            onSubmit(res.data)
            return ''
        } else if (res.status === 400){
            useNotification(
            'Ops!',
            'Oportunidade não encontrada, comentário não será salvo.',
            'danger'
        )
        return
        }
        
        useNotification(
            'Ops!',
            'Erro ao salvar comentário.',
            'danger'
        )
        return ''
    })
    setText('')
}

export const CommentBoxTextField = ({defaultValue, value, onChange, id='unknown'}) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [text, setText] = useState(defaultValue || value)

    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleChange = (event) => {
        setText(event.target.value)
        onChange(event)
    }
    const handleMenuClick = (value) => {
        const markdown = markdownTranslator[value]
        const new_text = `${text} ${markdown.add}`
        handleChange({target: {value: new_text}})
        handleClose()
    }

    return (
    <Box className='opportuniy-comment-box-active' gap='.5rem' display='flex' flexDirection='column' alignItems='flex-start'>
        {/* <Tooltip title='Adicionar elementos'> */}
            <Button 
                id={`basic-element-button-${id}`}
                aria-controls={open ? `basic-element-menu-${id}` : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                INSERIR ELEMENTO <KeyboardArrowDownIcon />
            </Button>
        {/* </Tooltip> */}
        <Menu 
        id={`basic-element-menu-${id}`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': `basic-element-button-${id}`,
          },
        }}
        >
            {Object.entries(markdownTranslator).map(([key, value]) => (
                <MenuItem onClick={() =>handleMenuClick(key)}>
                     <ListItemIcon>
                        {value.icon}
                    </ListItemIcon>
                    <ListItemText>
                        {value.label}
                    </ListItemText>
                    </MenuItem>
            ))}
            
        </Menu>
        <TextField
            autoFocus={true}

            fullWidth
            size='small'
            multiline={true}
            maxRows={8}
            value={text}
            onChange={handleChange}
        />
    </Box>
        
    )
} 

const CommentBox = ({ cardId, JourneyId, onSubmit, disabled }) => {
    const [active, setActive] = useState(false)
    const [text, setText] = useState('')

    useEffect(()=>{
        window.commentOpen = active
        return () => {
            window.commentOpen = null
        }
    }, [active])

    return (
        <>
            {active ?
                <>
                    <CommentBoxTextField 
                        value={text}
                        onChange={({ target }) => setText(target.value)}
                        id='main'
                    />
                    <Box >
                        <Button
                            variant='contained'
                            onClick={() => {
                                postMessage(cardId, JourneyId, onSubmit, setText, setActive)
                            }}
                        >
                            Salvar
                        </Button>
                        <Button onClick={() => {
                            setActive(false)
                            setText('')
                        }}>
                            Cancelar
                        </Button>
                    </Box>
                </>
                :
                <Box
                    onClick={() => disabled ? ()=>{} : setActive(true)}
                    className={`opportuniy-comment-box ${disabled ? 'disabled' : ''}`}>
                    {disabled ? "Necessário salvar para comentar." : "Escreva um comentário"}
                </Box>
            }
        </>
    )
}

export default CommentBox